define('app/models/Column',['require','glu/model','app/config/aggregateOptions','glu/util'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		AGGREGATE_OPTIONS = require('app/config/aggregateOptions'),
		_ = require('glu/util');

	var Column = Model.extend({

		initialize: function() {
			this.set('manualAsName', false);
		},

		getField: function() {
			return this.get('fieldObject');
		},
		getSort: function() {
			return this.attributes.sort;
		},
		setSort: function(order, priority) {
			this.set('sort', {
				order: order,
				priority: priority
			});
		},
		getAggregation: function() {
			return this.attributes.aggregation;
		},
		setIsHidden: function(value) {
			this.attributes.isHidden = value;
		},
		getIsHidden: function() { // deprecated
			return this.attributes.isHidden;
		},
		isHidden: function() {
			return this.attributes.isHidden;
		},
		setAggregation: function(value) {
			this.set('aggregation', value);
		},
		hasAggregation: function() {
			return this.get('aggregation') !== undefined;
		},
		isMeasure: function() {
			if (this.hasAggregation()) {
				return true;
			} else {
				return this.get('segmentId') || this.get('columnType') === 'FUNCTION' ? false : this.getField().isMeasure();
			}
		},
		isDimension: function() {
			return this.get('segmentId') || this.get('columnType') === 'FUNCTION' ? true : this.getField().isDimension();
		},
		canBeGrouped: function() {
			return true;
		},
		dataType: function() {
			return this.getField().dataType();
		},

		fieldName: function() {
			if (this.get('columnType') === 'COUNT') {
				return this.getField().name;
			} else {
				var name = this.get('segmentId') || this.get('columnType') === 'FUNCTION' ? this.get('name') : this.getField().displayName();
				return name;
			}
		},

		functionName: function() {
			if (this.get('asName')) {
				return this.get('asName');
			} else {
				return this.get('name');
			}
		},

		fieldDescription: function() {
			return this.getField().description ? this.getField().description() : null;
		},

		displayName: function(options) {
			if (this.get('asName') !== undefined) {
				return this.get('asName');
			} else {
				var name = this.getField() ? this.getField().displayName() : null;
				if (options && options.excludeAggregation) {
					return name;
				}
				return this.wrapNameInAggregation(name);
			}
		},

		getAsName: function() {
			return this.get('asName');
		},
		setAsName: function(value) {
			this.set('asName', value);
		},

		isManualAsName: function() {
			return this.get('manualAsName');
		},
		setManualAsName: function(value) {
			this.set('manualAsName', value);
		},

		fieldQualifiedName: function() {
			var qualifiedName;

			if (this.get('segmentId') || this.get('columnType') === 'FUNCTION') {
				qualifiedName = this.functionName();
			} else {
				if (_.isFunction(this.getField().qualifiedName)) {
					qualifiedName = this.getField().qualifiedName();
				} else if (_.isFunction(this.getField().displayName)) {
					qualifiedName = this.getField().displayName();
				} else {
					qualifiedName = this.getField().name();
				}
			}

			return qualifiedName;
		},

		qualifiedName: function() {
			return this.wrapNameInAggregation(this.fieldQualifiedName());
		},

		wrapNameInAggregation: function(name) {
			if (this.getAggregation()) {
				var result = name;
				var options = AGGREGATE_OPTIONS[this.isMeasure() ? 'MEASURE' : 'DIMENSION'];
				var matchedOption = _.findWhere(options, {
					value: this.getAggregation()
				});
				if (matchedOption) {
					result = matchedOption.label + '(' + name + ')';
				}

				if (this.isPercentage()) {
					result = result + ', %';
				}
				return result;
			}
			return name;
		},

		fieldId: function() {
			return this.attributes.fieldId;
		},

		segmentId: function() {
			return this.attributes.segmentId;
		},

		remove: function() {
			this.collection.remove(this);
		},
		setDefaultAggregation: function() {
			this.setAggregation(this.isMeasure() ? 'SUM' : 'COUNTD');
		},
		setArrangement: function(index) {
			this.set('arrangement', index);
		},
		getArrangement: function() {
			return this.get('arrangement');
		},

		// REVIEW: The count column should really be a subclass.
		isCountColumn: function() {
			return this.get('columnType') === 'COUNT';
		},
		isSegmentColumn: function() {
			return this.get('columnType') === 'SEGMENT';
		},
		getEnumeration: function() {
			if (this.getField() && _.isFunction(this.getField().getEnumeration)) {
				return this.getField().getEnumeration();
			}
			return null;
		},
		getFieldType: function() {
			if (this.getField() && _.isFunction(this.getField().dataType)) {
				return this.getField().dataType();
			}
			if (this.getField() && this.get('columnType') === 'FUNCTION') {
				return this.getField().type;
			}
			return null;
		},

		getDisplayFormat: function() {
			//special case for 'COUNT' and 'SEGMENT' column
			// since it's 'fieldObject' is not a copy of a specific Field
			if (this.isCountColumn() || this.isSegmentColumn()) {
				return undefined;
			}
			return this.getField() && this.get('columnType') !== 'FUNCTION' ? this.getField().getDisplayFormat() : null;
		},

		isPercentage: function() {
			return this.get('isPercentage');
		},

		setPercentage: function(isPercentage) {
			this.set('isPercentage', isPercentage);
		}

	});
	return Column;
});

